import Image from 'next/image';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { AlertTriangle, Paperclip, Trash2 } from 'react-feather';
import Icon from '../atoms/Icon';
import Text from '../atoms/Text';

const FileUpload = ({
    isError,
    variant,
    UploadLabel,
    UploadSubText,
    iconSrc,
    iconAlt,
    UploadLabelStyle,
    className,
    name,
    register,
    watch,
    deleteFile,
    onChange,
    accept,
    multiple = false,
    imgClass,
    UploadSubTextStyle,
    uploadClass,
    onSubTextClick = () => { },
    onFileClick = () => { },
    UploadLabelComponent
}) => {
    const [file, setFile] = useState([]);
    const fileType = {
        default: 'default',
        uploadDrag: 'uploadDrag',
        uploadButton: 'uploadButton'
    };

    const inputRef = useRef();

    const uploadSingleFile = (e) => {
        onChange(e.target.files);
        e.target.files && e.target.files[0] && setFile(multiple ? [...file, e.target.files[0]] : [e.target.files[0]]);
    };

    return (
        <div className="flex flex-wrap w-full">
            {fileType[variant] === 'default' && (
                <>
                    {watch(name)?.length > 0
                        && Array.from(watch(name))?.map((item, index) => (
                            <div
                                className="relative group w-16 h-16  overflow-hidden  border border-neutral-300 mx-2 p-2 rounded-sm text-center"
                                key={item}
                            >
                                <div className="relative">
                                    <Image
                                        className="m-auto object-cover object-center w-[86px] h-[86px]"
                                        src={URL.createObjectURL(item)} width="86" height="86" alt="file"
                                    />
                                    <div
                                        className="absolute top-0 left-0 w-full h-full justify-center bg-neutral-500 hidden group-hover:flex"
                                        onClick={() => deleteFile(index)}
                                    >
                                        <Image className="cursor-pointer" src="/images/icons/delete-w.svg" width="14" height="14" alt="delete" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    <div
                        className={` flex items-center gap-8 relative justify-center text-center ${isError ? 'border-error-300' : 'border-neutral-300'} ${uploadClass}`}
                    >
                        <div className={`upload_pic bg-[url('/images/upload-picture.svg')] w-16 h-16 ${watch(name)?.length ? 'hidden' : ''} ${imgClass} `}>
                        </div>
                        <input
                            id={name}
                            type="file"
                            className=" w-full h-full absolute left-0 top-0 opacity-0 cursor-pointer"
                            {...register(name)}
                            accept={accept}
                        />

                        <div className="flex flex-col items-start">
                            {iconSrc && <Icon iconSrc={iconSrc} iconAlt={iconAlt} className="mx-auto w-4" />}
                            <Text variant='body' className={`text-gray-100 font-normal ${UploadLabelStyle}`}>{UploadLabel}</Text>
                            <Text variant='bodySmall' className={`text-gray-100 ${UploadSubTextStyle}`} onClick={onSubTextClick}>{UploadSubText}</Text>
                        </div>
                    </div>
                </>
            )
            }
            {
                fileType[variant] === 'uploadDrag' && (
                    <>
                        <div className={`border border-dashed border-gray-300 rounded-lg w-full ${className}`}>
                            <div
                                className={`relative w-full h-[128px] flex flex-col justify-center text-center 
                        ${isError ? 'border-error-300' : 'border-neutral-300'}`}
                            >
                                <input
                                    type="file"
                                    className="absolute w-full h-full left-0 top-0 opacity-0 cursor-pointer z-10"
                                    onChange={uploadSingleFile}
                                    ref={inputRef}
                                    accept={accept}

                                />
                                <div className="p-2 text-center">
                                    {iconSrc && <Icon iconSrc={iconSrc} iconAlt={iconAlt} iconWidth='50' iconHeight='50' className={`mx-auto w-9`} />}
                                    <Text className={`text-gray-100 ${UploadLabelStyle}`}>
                                        {UploadLabel}
                                    </Text>
                                </div>
                            </div>

                        </div>
                        {
                            file.length > 0 && (
                                file.map((item, index) => (
                                    <div className="relative group w-full overflow-hidden mt-1.5 rounded-sm text-center" key={item}>
                                        <div className="relative flex items-center gap-4">
                                            <div className="flex items-center gap-2 py-1 group cursor-pointer" onClick={onFileClick}>
                                                <Paperclip size={14} className='text-gray-200' />
                                                <Text variant='caption' fontWeight='font-medium' className="text-gray-100 group-hover:text-primary-300">{item?.name}</Text>
                                            </div>
                                            <div
                                                className="cursor-pointer hidden group-hover:block"
                                                onClick={() => { deleteFile(index); setFile([]); inputRef.current.value = ''; }}
                                            >
                                                <Trash2 size={14} className='text-gray-200 hover:text-gray-100' />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )
                        }
                        {UploadSubText && <div className='flex items-center gap-2 mt-2'>
                            <AlertTriangle size={14} className='text-gray-200' />
                            <Text variant='caption' fontWeight='font-medium' className="text-gray-100"> {UploadSubText}</Text>
                        </div>}
                    </>
                )
            }
            {
                fileType[variant] == 'uploadButton' && (
                    <div className={`${className} `}>
                        <div className={`relative ${className} h-[38px] py-2 flex flex-col justify-center text-center ${isError ? 'border-error-300' : 'border-neutral-300'}`}>
                            <input
                                type="file"
                                className="absolute w-full h-full left-0 top-0 opacity-0 cursor-pointer z-10"
                                onChange={uploadSingleFile}
                                accept={accept}
                            />
                            <div className="flex gap-2 px-2 py-2 text-center">
                                {iconSrc && <Icon iconSrc={iconSrc} iconAlt={iconAlt} className="w-4" />}
                                <Text className={`text-sm self-center text-neutral-700 mt-1 font-normal ${UploadLabelStyle}`}>{UploadLabel}</Text>
                            </div>
                        </div>
                        {file?.length > 0
                            && file.map((item, index) => (
                                <div className="relative group w-[395px]   overflow-hidden mt-1  rounded-sm text-center" key={item}>
                                    <div className="flex justify-between">
                                        <div className="flex gap-2 py-1">
                                            <Icon iconSrc="/images/icons/attachment.svg" iconAlt="attachnent" className="" />
                                            <Text className="text-primary-900 text-sm">abc.png</Text>
                                        </div>

                                        <Image className="cursor-pointer" src="/images/icons/delete-icon.svg" width="35" height="35" alt="delete" />
                                    </div>
                                </div>
                            ))}
                    </div>
                )
            }
        </div >
    );
};

FileUpload.defaultProps = {
    isError: false,
    variant: 'default',
    UploadLabel: 'Drop your file(s) here or browse',
    UploadSubText: 'subtitle',
    iconSrc: '',
    iconAlt: '',
    UploadLabelStyle: '',
    UploadSubTextStyle: '',
    className: '',
    name: 'upload',
    register: () => { },
    watch: {},
    deleteFile: () => { },
    accept: '*',
    onChange: () => { }
};

FileUpload.propTypes = {
    isError: PropTypes.bool,
    variant: PropTypes.oneOf(['default']),
    UploadLabel: PropTypes.node,
    UploadSubText: PropTypes.string,
    iconSrc: PropTypes.string,
    iconAlt: PropTypes.string,
    UploadLabelStyle: PropTypes.string,
    UploadSubTextStyle: PropTypes.string,
    className: PropTypes.string,
    name: PropTypes.string,
    register: PropTypes.func,
    watch: PropTypes.shape({}),
    deleteFile: PropTypes.func,
    accept: PropTypes.string,
    onChange: PropTypes.func
};

export default FileUpload;
